import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tps-assistant-message',
  imports: [],
  templateUrl: './assistant-message.component.html',
  styleUrl: './assistant-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssistantMessageComponent {
  
  role = input<'user' | 'assistant' | 'system' | 'tool-response'>();

  sender = input<string>();
  sentDate = input<Date>();
  messageContent = input<string>();
}
